<div class="scrollmenu">
    <mat-form-field style="padding-top: 15px;" appearance="outline" floatLabelType="never">
        <mat-label>Filter</mat-label>
        <input matInput (keyup.enter)="applyFilter($event)" placeholder="Press enter to search" #input>
    </mat-form-field>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 data-grid-table"
        *ngIf="dataSource.data.length > 0">
        <ng-container *ngFor="let column of columns" [matColumnDef]="column.columnDef">
            <div *ngIf="column.columnDef=='Id'; else elseBlock">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="$event ? toggleAllRows() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)">
                    </mat-checkbox>
                </td>
            </div>
            <ng-template #elseBlock>
                <th mat-header-cell *matHeaderCellDef>
                    {{column.header}}
                </th>
                <td mat-cell *matCellDef="let row">
                    <div *ngIf="(isString(column.cell(row)))">{{column.cell(row)}}</div>
                    <div *ngIf="!(isString(column.cell(row)))">
                        <div [innerHTML]="(column.cell(row))"></div>
                    </div>
                </td>
            </ng-template>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>
<mat-paginator #paginator [length]="totalCount"
              [pageSize]="pageSize"
              [pageSizeOptions]="pageSizeOptions"
              [pageIndex]="pageIndex"
              (page)="handlePageEvent($event)"
              aria-label="Select page">
</mat-paginator>